import { connect } from 'react-redux'
import verifyModal from './verifyModal';

export default connect()(verifyModal);
